import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ModuleGroupRoleDeleteRestrictedError extends CodedError {
  static get errorName() {
    return errorCodes.moduleGroupRoleDeleteRestrictedError.code;
  }

  constructor(message: string = errorCodes.moduleGroupRoleDeleteRestrictedError.message) {
    super(message);
    this.code = errorCodes.moduleGroupRoleDeleteRestrictedError.code;
    this.message = `${message} ${errorCodes.moduleGroupRoleDeleteRestrictedError.code}`;
    this.name = errorCodes.moduleGroupRoleDeleteRestrictedError.name;
    this.status = errorCodes.moduleGroupRoleDeleteRestrictedError.status;
  }
}